export const getCommitmentTypeId = commitmentType => {
  switch (commitmentType) {
    case "GREEN_DEAL":
    case "PLASTIC_BAG":
    case "OIL_INDUSTRY":
    case "WORK_MACHINE":
    case "AUTOMOTIVE_INDUSTRY":
    case "DEMOLITION":
    case "EMISSION_FREE_WORKSITE":
    case "EARLY_CHILDHOOD_EDUCATION":
    case "CONSTRUCTION_PLASTICS":
    case "GROCERY_INDUSTRY":
    case "GROCERY_INDUSTRY_WITH_MATERIAL":
      return 33554;
    case "MATERIAL":
      //return 549666 //PROD
      return 583644;
    case "CIRCULAR_ECONOMY":
      return 871646;
    default:
      return undefined;
  }
};

export const getCommitmentTypeName = commitmentType => {
  switch (commitmentType) {
    case "GREEN_DEAL":
      return "Green Deal";
    case "MATERIAL":
      return "Materiaalitehokkuuden";
    default:
      return "Sitoumus";
  }
};

export const isMaterialOrGD = commitmentType => {
  return (
    getCommitmentTypeId(commitmentType) === 33554 ||
    getCommitmentTypeId(commitmentType) === 583644
  );
};



// WEBPACK FOOTER //
// ./src/components/materialCommitment/helpers/Categories.js